<template>

    <!-- SELECT A PRINT STYLE -->
    <div class="print-styles">
      <ul class="print-styles-grid d-flex justify-content-around flex-wrap">
        <li v-for="(ps, index) in customband.product.print_styles" @click="selectPrintStyle(ps)" v-bind:class="{ 'active': customband.customization.printStyle.id === ps.id }">
          <div class="text-center"><img v-bind:src="ps.image" v-bind:alt="ps.print_style.name"></div>
          <h5 class="text-center">{{ ps.print_style.name }}</h5>
          <p v-if="ps.min_qty" class="text-center">Minimum Qty: {{ ps.min_qty }}</p>
          <p v-if="ps.min_qty <= 1" class="text-center"><strong class="badge badge-success">No minimum!</strong></p>
          <!--<p class="text-center"><popover tiers-src="ps.product_pricing_applied" t-type="'product'" per-band="perBand" ng-if="!noPhrase" title-text="{{ customband.product.name }} {{ ps.print_style.name }}"></popover></p>-->
        </li>
      </ul>

      <steps-bar></steps-bar>
    </div>

</template>

<script>
  import { mapState } from 'vuex'
  import _cloneDeep from 'lodash/cloneDeep'

  let stateName = 'bandbuilder.silicone.imprint'

  export default {
    data () {
      return {}
    },
    computed: {
      localComputed () {

      },
      ...mapState([
        // map this.customband to store.state.customband
        'customband',
        'customstates'
      ])
    },
    methods: {
      selectPrintStyle (printStyle) {
        printStyle = _cloneDeep(printStyle)
        this.$store.dispatch('customband/selectPrintStyle', printStyle)
        this.$root.$data.fixedPreview.renderProduct()
      }
    },
    created () {
      this.$store.dispatch('customstates/stepIsCompleted', stateName)
      this.$store.dispatch('customband/checkCompletion')
    },
    mounted () {
      // console.log('customband', this.customband)
    }
  }
</script>
